import React from "react";
import { useState } from "react";
import Calendar from "../../components/calendar/Calendar";


const ReservationPage = () => {
    const [inProgress, setInProgress] = useState(false)
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    return (
        <div className="reservation-page-container">
            <Calendar setInProgress={setInProgress} setIsLoggedIn={setIsLoggedIn}></Calendar>
            
        </div>


    )
}

export default ReservationPage